module.exports = __webpack_public_path__ + "static/media/244.9fb95ea2.svg";